import { Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useMemo, useCallback } from "react";
import { EmployeeBankInfoSchema } from "../../config/forms/employeeFormConfig";

const EmployeeBankInfoForm = ({ 
  textFieldStyles, 
  errors, 
  touchedFields = {},
  isSubmitted,
  register, 
  setCurrentSchema, 
}) => {
  useEffect(() => {
    setCurrentSchema(EmployeeBankInfoSchema);
  }, []);

  const shouldShowError = useCallback((fieldName) => !!errors[fieldName] && (touchedFields[fieldName] || isSubmitted), [errors, touchedFields, isSubmitted]);

  const fields = useMemo(() => [
    { name: "bank_name", label: "Bank Name", sm: 6 },
    { name: "account_holder_name", label: "Account Holder Name", sm: 6 },
    { name: "account_no", label: "Account Number", sm: 6 },
    { name: "ifsc_code", label: "IFSC Code", sm: 6 },
    { name: "branch", label: "Branch Name", sm: 12 },
  ], []);

  return (
    <Grid container spacing={3} sx={{ padding: { xs: 0, sm: "0 8%" } }}>
      <Grid item xs={12}><Typography variant="h6" color="#DFA828" sx={{ fontWeight: 600 }}>Bank Details</Typography></Grid>
      {fields.map((field) => (
        <Grid item xs={12} sm={field.sm} key={field.name}>
          <TextField
            {...register(field.name)}
            error={shouldShowError(field.name)}
            helperText={shouldShowError(field.name) ? errors[field.name]?.message : ""}
            label={field.label}
            fullWidth
            size="small"
            InputProps={textFieldStyles.input}
            InputLabelProps={textFieldStyles.label}
            FormHelperTextProps={textFieldStyles.helperText}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default EmployeeBankInfoForm;